import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { initialViewState } from 'redux/reducers/genes/getInitialState';
var downsampledGenesLoaded = function downsampledGenesLoaded(state, action) {
  var _action$payload = action.payload,
    componentUuid = _action$payload.componentUuid,
    genes = _action$payload.genes,
    _action$payload$newGe = _action$payload.newGenes,
    newGenes = _action$payload$newGe === void 0 ? undefined : _action$payload$newGe,
    loadedRequestSignature = _action$payload.loadedRequestSignature;
  var cellOrderToStore = state.expression.downsampled.cellOrder;
  var loadedRequestSignatureToStore = state.expression.downsampled.loadedRequestSignature;

  // If there's any data to store, load it
  if (newGenes) {
    var orderedGeneNames = newGenes.orderedGeneNames,
      rawExpression = newGenes.rawExpression,
      stats = newGenes.stats,
      cellOrder = newGenes.cellOrder;
    state.expression.downsampled.matrix.setGeneExpression(orderedGeneNames, rawExpression, stats);
    cellOrderToStore = cellOrder;
    loadedRequestSignatureToStore = loadedRequestSignature;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    expression: _objectSpread(_objectSpread({}, state.expression), {}, {
      views: _objectSpread(_objectSpread({}, state.expression.views), {}, _defineProperty({}, componentUuid, _objectSpread(_objectSpread(_objectSpread({}, initialViewState), state.expression.views[componentUuid]), {}, {
        fetching: false,
        error: false,
        data: genes,
        markers: false
      }))),
      downsampled: _objectSpread(_objectSpread({}, state.expression.downsampled), {}, {
        loading: [],
        error: false,
        cellOrder: cellOrderToStore,
        loadedRequestSignature: loadedRequestSignatureToStore
      })
    })
  });
};
export default downsampledGenesLoaded;